import { createIcon } from "@chakra-ui/react";

export const MenuIconTasks = createIcon({
  displayName: "MenuIconTasks",
  viewBox: "6.5 4.5 16.014 20",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21.5 14V5.5a1 1 0 0 0-1-1H7.5a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h6" />
      <circle cx="10" cy="10.5" r="0.75" fill="currentColor" stroke="none" />
      <circle cx="10" cy="14.5" r="0.75" fill="currentColor" stroke="none" />
      <circle cx="10" cy="18.5" r="0.75" fill="currentColor" stroke="none" />
      <line x1="12.5" y1="10.5" x2="18" y2="10.5" />
      <line x1="12.5" y1="14.5" x2="18" y2="14.5" />
      <line x1="12.5" y1="18.5" x2="15" y2="18.5" />
      <g transform="translate(19.2 20.1) rotate(-45) scale(1.37 1.05) rotate(45) translate(-19.2 -20.1)" stroke="none" fill="currentColor">
        <path d="M21.2744 16.5441C21.1968 16.4643 21.1069 16.4269 21.0034 16.4285C20.8999 16.4301 20.8116 16.4725 20.7386 16.5555L20.1434 17.2179L21.8133 18.9415L22.4145 18.2726C22.4861 18.1945 22.5165 18.0935 22.515 17.9829C22.5135 17.8738 22.4769 17.7745 22.4039 17.6997L21.2744 16.5441Z" />
        <path d="M18.1553 23.0008C17.9346 23.0756 17.7154 23.1538 17.4962 23.2303C17.2755 23.3084 17.0563 23.3881 16.8371 23.4663C16.318 23.6486 16.0273 23.7495 15.9664 23.7674C15.907 23.7869 15.942 23.5265 16.0729 22.9845L16.4855 21.2837L19.6136 17.8038L21.282 19.521L18.1553 23.0008Z" />
      </g>
    </g>
  ),
});
